module.exports = __webpack_public_path__ + "img/csr9.8ce6eb75.jpg";